import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WindowCloseButton from '../WindowCloseButton';
import WindowDisabledButton from '../WindowDisabledButton';
import './styles.css';

class WindowOptions extends Component {
	render() {
		const { history } = this.props;
		return (
			<div className="window-options">
				<WindowCloseButton history={history} />
				<WindowDisabledButton />
				<WindowDisabledButton />
			</div>
		);
	}
}

WindowOptions.propTypes = {
	history: PropTypes.object
};

export default WindowOptions;
